<app-auth-shell
  panelClass="max-w-[560px]"
  mainClass="min-h-[calc(100vh-180px)]"
>
  @if (errorMessage) {
    <section class="p-6 text-center sm:p-10">
      <div
        class="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full border border-red-secondary bg-red-primary text-red-secondary"
      >
        <span class="material-symbols-outlined text-[24px]">error</span>
      </div>
      <h1
        class="font-spaceGrotesk text-[28px] font-semibold leading-tight text-inverted-neutral"
      >
        Unable to continue
      </h1>
      <p
        class="mx-auto mt-3 max-w-md inter-300 text-[15px] leading-6 text-support-text"
      >
        {{ errorMessage }}
      </p>
    </section>
  }

  @if (!errorMessage) {
    <section class="p-6 sm:p-10">
      <div class="mb-8 text-center">
        <div
          class="mb-3 inline-flex rounded-full border border-periwinkle-border bg-periwinkle-soft px-3 py-1 inter-500 text-[12px] text-periwinkle"
        >
          Secure sign in
        </div>
        <h1
          class="font-spaceGrotesk text-[32px] font-semibold leading-tight text-inverted-neutral sm:text-[40px]"
        >
          Sign in
        </h1>
        <p class="mt-3 inter-300 text-[15px] leading-6 text-support-text">
          Continue to
          <span class="inter-600 text-inverted-neutral">
            {{ applicationName }}
          </span>
        </p>
      </div>

      <div class="mx-auto flex max-w-md flex-col">
        @if (!twoFactor) {
          <input
            [formControl]="loginForm.controls.email"
            class="form-control mb-4"
            placeholder="Email"
            type="text"
          />
        }
        @if (!twoFactor) {
          <input
            [formControl]="loginForm.controls.password"
            class="form-control mb-8"
            placeholder="Password"
            type="password"
          />
        }
        @if (twoFactor) {
          <input
            [formControl]="loginForm.controls.twoFactorCode"
            class="form-control mb-8"
            placeholder="2FA Code"
            type="text"
          />
        }

        <div class="flex justify-center">
          <button
            type="button"
            [disabled]="loading"
            (click)="login()"
            matRipple
            class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[16px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
          >
            {{ loading ? 'Continuing...' : 'Log In' }}
          </button>
        </div>
      </div>
    </section>
  }
</app-auth-shell>
